'use strict';

// TODO, semver-major: delete
module.exports = require('math-intrinsics/mod');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/mod.js
// module id = 845
// module chunks = 231608221292675